import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import apiPrivateAntesala from "../../../config/ConfigPrivate";
import Usuario from "../../page/usuarios/Usuario";
import RestPrivateAntesala from "../../../helpers/RestPrivateApi";
import Alerts from "../../components/Alerts/Alerts";

const UsuarioController = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const isNuevoUsuario = window.location.pathname.includes('/nuevo');
  const [provincias, setProvincias] = useState(null);
  const [usuario, setUsuario] = useState(null);
  const [facturacion, setFacturacion] = useState(null);
  const [loading, setLoading] = useState(null);
  const [filePreview, setFilePreview] = useState({
    comprobante_afip: null,
    comprobante_cbu: null,
    comprobante_entidad: null,
    comprobante_identificador: null,
  });

  const handleFilePreview = (file, fieldName) => {
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setFilePreview(prev => ({
          ...prev,
          [fieldName]: reader.result
        }));
      };
      reader.readAsDataURL(file);
    } else if (file && file.type === 'application/pdf') {
      // Para PDFs, mostramos un icono o texto indicativo
      setFilePreview(prev => ({
        ...prev,
        [fieldName]: 'pdf'
      }));
    } else if (file) {
      // Para otros tipos de archivo, mostramos el nombre
      setFilePreview(prev => ({
        ...prev,
        [fieldName]: file.name
      }));
    }
  };

  const onClick = async (e, value) => {
    switch (e.target.name) {
      case "aplicar":
        {
          let formData = new FormData();
          let formFacturacion = new FormData();
          formData.append("_method", "PUT");
          formData.append("nombre", usuario.nombre);
          formData.append("apellido", usuario.apellido);
          formData.append("telefono", usuario.telefono);
          formData.append("direccion", usuario.direccion);
          formData.append("provincia", usuario.provincia);
          formData.append("localidad", usuario.localidad);

          // Datos de facturación - Solo para usuarios que NO son espectadores
          const isEspectador = usuario.tipo === 'esp' || usuario.rol?.[0]?.nombre === 'esp';

          if (facturacion && !isEspectador) {
            formFacturacion.append("_method", "PUT");
            formFacturacion.append("entidad", facturacion.entidad || "");
            formFacturacion.append("cbu", facturacion.cbu || "");
            formFacturacion.append("dato_fiscal", facturacion.dato_fiscal || "");
            formFacturacion.append("porcentaje", facturacion.porcentaje || "");

            // Archivos de comprobantes
            if (filePreview.comprobante_afip) {
              formFacturacion.append("comprobante_afip", facturacion.comprobante_afip);
            }
            if (filePreview.comprobante_cbu) {
              formFacturacion.append("comprobante_cbu", facturacion.comprobante_cbu);
            }
            if (filePreview.comprobante_entidad) {
              formFacturacion.append("comprobante_entidad", facturacion.comprobante_entidad);
            }
          }

          if (usuario.password && usuario.repeat_password) {
            if (usuario.password !== usuario.repeat_password) {
              return Alerts({
                msg: "Alert",
                title: "La contraseña debe ser la misma",
                code: "200",
                type: "warning",
              });
            }
            formData.append("password", usuario.password);
            formData.append("repeat_password", usuario.repeat_password);
          }

          const response = await RestPrivateAntesala({
            url: `/usuarios/${usuario.id}`,
            formData: formData,
            method: "post",
            setLoading: setLoading,
          });

          //Error
          if (response.success == 201 || response.status == 200) {

            Alerts({
              msg: "Alert",
              title: response.data.msg,
              code: "200",
              type: "success",
            });

            // Solo actualizar facturación si NO es espectador
            if (facturacion && !isEspectador) {
              const responseFacturacion = await RestPrivateAntesala({
                url: `/usuario-facturacion/${facturacion.id}`,
                formData: formFacturacion,
                method: "post",
                setLoading: setLoading,
              });


              if (responseFacturacion.success == 201 || responseFacturacion.status == 200) {
                Alerts({
                  msg: "Alert",
                  title: "Datos de facturación actualizados correctamente",
                  code: "200",
                  type: "success",
                });
              }
            }
            //return navigate(`/dashboard/cupones/${response.data.data.id}`);
          } else {
            if (typeof response.data.msg === "string") {
              return Alerts({
                msg: "Alert",
                title: response.data.msg,
                code: "200",
                type: "success",
              });
            }

            Object.keys(response.data.msg).map((key) => {
              return Alerts({
                msg: "Alert",
                title: response.data.msg[key][0],
                code: "401",
                type: "error",
              });
            });
          }
        }
        break;
      case "guardar":
        {
          // Validaciones
          if (!usuario.nombre || !usuario.apellido || !usuario.telefono) {
            return Alerts({
              msg: "Alert",
              title: "Nombre, apellido y teléfono son obligatorios",
              code: "200",
              type: "warning",
            });
          }

          if (!usuario.email || !usuario.password || !usuario.repeat_password) {
            return Alerts({
              msg: "Alert",
              title: "Email y contraseña son obligatorios",
              code: "200",
              type: "warning",
            });
          }

          if (usuario.password !== usuario.repeat_password) {
            return Alerts({
              msg: "Alert",
              title: "Las contraseñas no coinciden",
              code: "200",
              type: "warning",
            });
          }

          if (!usuario.tipo) {
            return Alerts({
              msg: "Alert",
              title: "Debe seleccionar un tipo de usuario",
              code: "200",
              type: "warning",
            });
          }

          // Validar campos específicos según el tipo
          if (usuario.tipo === 'prd' && !usuario.productor?.nombre) {
            return Alerts({
              msg: "Alert",
              title: "El nombre del productor es obligatorio",
              code: "200",
              type: "warning",
            });
          }

          if (usuario.tipo === 'sala' && (!usuario.sala?.razon_social || !usuario.sala?.nombre)) {
            return Alerts({
              msg: "Alert",
              title: "La razón social y nombre de la sala son obligatorios",
              code: "200",
              type: "warning",
            });
          }

          let formData = new FormData();

          // Datos básicos del usuario
          formData.append("nombre", usuario.nombre);
          formData.append("apellido", usuario.apellido);
          formData.append("telefono", usuario.telefono);
          formData.append("email", usuario.email);
          formData.append("password", usuario.password);
          formData.append("repeat_password", usuario.repeat_password);
          formData.append("direccion", usuario.direccion || "");
          formData.append("provincia", usuario.provincia || "");
          formData.append("localidad", usuario.localidad || "");
          formData.append("status_id", 1); // Activo por defecto
          formData.append("tipo", usuario.tipo);

          // Imagen de perfil
          if (usuario.imagen_logo_file) {
            formData.append("imagen_logo", usuario.imagen_logo_file);
          }

          // Datos específicos de Productor
          if (usuario.tipo === 'prd' && usuario.productor) {
            formData.append("productor-nombre", usuario.productor.nombre || "");
            formData.append("productor-telefono", usuario.productor.telefono || "");
            formData.append("productor-prd_email", usuario.productor.prd_email || "");
            formData.append("productor-descripcion", usuario.productor.descripcion || "");
            formData.append("productor-direccion", usuario.productor.direccion || "");
            formData.append("productor-provincia", usuario.productor.provincia || "");
            formData.append("productor-localidad", usuario.productor.localidad || "");
          }

          // Datos específicos de Sala
          if (usuario.tipo === 'sala' && usuario.sala) {
            formData.append("sala-razon_social", usuario.sala.razon_social || "");
            formData.append("sala-nombre", usuario.sala.nombre || "");
            formData.append("sala-telefono", usuario.sala.telefono || "");
            formData.append("sala-email", usuario.sala.email || "");
            formData.append("sala-descripcion", usuario.sala.descripcion || "");
            formData.append("sala-direccion", usuario.sala.direccion || "");
            formData.append("sala-provincia", usuario.sala.provincia || "");
            formData.append("sala-whatsapp_button", usuario.sala.whatsapp_button || "");
            formData.append("sala-website", usuario.sala.website || "");
            formData.append("sala-url_facebook", usuario.sala.url_facebook || "");
            formData.append("sala-url_instagram", usuario.sala.url_instagram || "");

            // Imagen de sala
            if (usuario.sala.imagen_logo_file) {
              formData.append("sala-imagen_logo", usuario.sala.imagen_logo_file);
            }
          }

          // Datos de facturación
          if (facturacion) {
            formData.append("entidad", facturacion.entidad || "");
            formData.append("cbu", facturacion.cbu || "");
            formData.append("dato_fiscal", facturacion.dato_fiscal || "");
            formData.append("porcentaje", facturacion.porcentaje || "");

            // Archivos de comprobantes
            if (facturacion.comprobante_afip) {
              formData.append("comprobante_afip", facturacion.comprobante_afip);
            }
            if (facturacion.comprobante_cbu) {
              formData.append("comprobante_cbu", facturacion.comprobante_cbu);
            }
            if (facturacion.comprobante_entidad) {
              formData.append("comprobante_entidad", facturacion.comprobante_entidad);
            }
          }

          const response = await RestPrivateAntesala({
            url: `/usuarios`,
            formData: formData,
            method: "post",
            setLoading: setLoading,
          });

          //Error
          if (response.success == 201 || response.status == 200) {
            Alerts({
              msg: "Alert",
              title: response.data.msg,
              code: "200",
              type: "success",
            });
            return navigate(`/dashboard/usuarios/${response.data.data.id}`);
          } else {
            if (typeof response.data.msg === "string") {
              return Alerts({
                msg: "Alert",
                title: response.data.msg,
                code: "200",
                type: "error",
              });
            }

            Object.keys(response.data.msg).map((key) => {
              return Alerts({
                msg: "Alert",
                title: response.data.msg[key][0],
                code: "401",
                type: "error",
              });
            });
          }
        }
        break;
    }
  };

  const onChange = async (e, value) => {
    switch (e.target.name) {
      case "tipo":
        {
          const tipoValue = e.target.value;

          setUsuario({
            ...usuario,
            tipo: tipoValue,
            // Inicializar estructuras según el tipo
            productor: tipoValue === 'prd' ? { nombre: '', telefono: '', prd_email: '', descripcion: '', direccion: '', provincia: '', localidad: '' } : usuario.productor,
            sala: tipoValue === 'sala' ? { razon_social: '', nombre: '', telefono: '', email: '', descripcion: '', direccion: '', provincia: '', whatsapp_button: '', website: '', url_facebook: '', url_instagram: '' } : usuario.sala,
          })
        }
        break;
      case "imagen_logo":
        {
          const file = e.target.files[0];
          if (file) {
            setUsuario({
              ...usuario,
              imagen_logo_file: file,
              imagen_logo: URL.createObjectURL(file)
            })
          }
        }
        break;
      case "email":
      case "provincia":
      case "localidad":
      case "direccion":
      case "apellido":
      case "nombre":
      case "telefono":
      case "password":
      case "repeat_password":
        {
          setUsuario({
            ...usuario,
            [e.target.name]: e.target.value
          })
        }
        break;
      // Campos de Productor
      case "productor-nombre":
      case "productor-telefono":
      case "productor-prd_email":
      case "productor-descripcion":
      case "productor-direccion":
      case "productor-provincia":
      case "productor-localidad":
        {
          const fieldName = e.target.name.replace('productor-', '');
          setUsuario({
            ...usuario,
            productor: {
              ...usuario.productor,
              [fieldName]: e.target.value
            }
          })
        }
        break;
      // Campos de Sala
      case "sala-razon_social":
      case "sala-nombre":
      case "sala-telefono":
      case "sala-email":
      case "sala-descripcion":
      case "sala-direccion":
      case "sala-provincia":
      case "sala-localidad":
      case "sala-whatsapp_button":
      case "sala-website":
      case "sala-url_facebook":
      case "sala-url_instagram":
        {
          const fieldName = e.target.name.replace('sala-', '');
          setUsuario({
            ...usuario,
            sala: {
              ...usuario.sala,
              [fieldName]: e.target.value
            }
          })
        }
        break;
      case "sala-imagen_logo":
        {
          const file = e.target.files[0];
          if (file) {
            setUsuario({
              ...usuario,
              sala: {
                ...usuario.sala,
                imagen_logo_file: file,
                imagen_logo: URL.createObjectURL(file)
              }
            })
          }
        }
        break;
      case "entidad":
      case "cbu":
      case "dato_fiscal":
      case "identificador":
      case "porcentaje":
      case "comprobante_afip":
      case "comprobante_cbu":
      case "comprobante_entidad":
      case "comprobante_identificador":
        {
          const fieldName = e.target.name;
          const value = e.target.type === 'file' ? e.target.files[0] : e.target.value;

          // Si es un archivo, generar previsualización
          if (e.target.type === 'file' && e.target.files[0]) {
            handleFilePreview(e.target.files[0], fieldName);
          }

          setFacturacion({
            ...facturacion,
            [fieldName]: value
          })
        }
        break;
    }
  };

  const fetchFilePreview = async (fileName, field) => {
    try {
      const response = await apiPrivateAntesala.get(`/usuario-facturacion/archivo/${fileName}`, {
        responseType: 'blob'
      });

      if (response.status === 200) {
        // Crear Object URL para vista previa en caché
        const objectUrl = URL.createObjectURL(response.data);

        setFilePreview(prev => ({
          ...prev,
          [field]: {
            url: objectUrl,
            fileName: fileName,
            isExisting: true,
            type: response.data.type,
            blob: response.data
          }
        }));
      }
    } catch (error) {
      console.error(`Error al cargar archivo ${fileName}:`, error);
    }
  };

  const fetchUser = async (setData, params, url, signal) => {
    const response = await apiPrivateAntesala.get(url, { params, signal });
    if (response.status == 201 || response.status == 200) {
      setData(response.data);
      if (response.data?.productor) {
        setFacturacion(response.data.facturacion)
        // Procesar archivos existentes
        const facturacionData = response.data.facturacion;

        ['comprobante_afip', 'comprobante_cbu', 'comprobante_entidad', 'comprobante_identificador'].forEach(field => {
          if (facturacionData?.[field]) {
            // Si el archivo viene codificado (ej: "liquidaciones/archivo.pdf")
            const fileName = facturacionData[field].split('/').pop();
            // Descargar y crear vista previa en caché
            fetchFilePreview(fileName, field);
          }
        });
      }
      if (response.data?.sala) {
        setFacturacion(response.data.facturacion)
        // Procesar archivos existentes
        const facturacionData = response.data.facturacion;

        ['comprobante_afip', 'comprobante_cbu', 'comprobante_entidad', 'comprobante_identificador'].forEach(field => {
          if (facturacionData?.[field]) {
            // Si el archivo viene codificado (ej: "liquidaciones/archivo.pdf")
            const fileName = facturacionData[field].split('/').pop();
            // Descargar y crear vista previa en caché
            fetchFilePreview(fileName, field);
          }
        });
      }
    }
  };

  const fetch = async (setData, params, url, signal) => {
    const response = await apiPrivateAntesala.get(url, { params, signal });
    if (response.status == 201 || response.status == 200) {
      setData(response.data);
    }
  };

  useEffect(() => {
    if (isNuevoUsuario && !usuario) {
      // Inicializar usuario vacío para nuevo usuario
      setUsuario({
        nombre: "",
        apellido: "",
        email: "",
        telefono: "",
        direccion: "",
        provincia: "",
        localidad: "",
        password: "",
        repeat_password: "",
        tipo: "",
        imagen_logo: "https://antesala.com.ar/assets/img/user-default.png",
        status: { nombre: "Activo" },
        rol: [{ nombre: "", descripcion: "Seleccionar tipo de usuario" }],
        created_at: new Date(),
        productor: {
          nombre: "",
          telefono: "",
          prd_email: "",
          descripcion: "",
          direccion: "",
          provincia: "",
          localidad: ""
        },
        sala: {
          razon_social: "",
          nombre: "",
          telefono: "",
          email: "",
          descripcion: "",
          direccion: "",
          provincia: "",
          whatsapp_button: "",
          website: "",
          url_facebook: "",
          url_instagram: "",
          imagen_logo: "https://antesala.com.ar/assets/img/sala-default.png"
        }
      });
      setFacturacion({
        entidad: "",
        cbu: "",
        dato_fiscal: "",
        porcentaje: "",
      });
    } else if (!usuario && id) {
      fetchUser(setUsuario, {}, `/usuarios/${id}`);
    }
  }, [id, isNuevoUsuario]);

  useEffect(() => {
    if (!provincias) {
      fetch(setProvincias, {}, `/provincias`);
    }
  }, []);

  // Cleanup de Object URLs al desmontar
  useEffect(() => {
    return () => {
      Object.values(filePreview).forEach(preview => {
        if (preview?.url && preview?.isExisting) {
          URL.revokeObjectURL(preview.url);
        }
      });
    };
  }, [filePreview]);

  if (!usuario || !provincias) {
    return "";
  }

  return (
    <Usuario
      data={usuario}
      facturacion={facturacion}
      provincias={provincias}
      onClick={onClick}
      onChange={onChange}
      filePreview={filePreview}
    />
  );
};

export default UsuarioController;
